import { render, staticRenderFns } from "./TexteHTML.vue?vue&type=template&id=4bf1ea6e&scoped=true"
import script from "./TexteHTML.vue?vue&type=script&lang=js"
export * from "./TexteHTML.vue?vue&type=script&lang=js"
import style0 from "./TexteHTML.vue?vue&type=style&index=0&id=4bf1ea6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf1ea6e",
  null
  
)

export default component.exports